import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const TextInputContainer = styled.div`
  position: relative;
`;
export const TextInputLabel = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  top: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";

    color: #ea6457;

    font-weight: bold;
  }
`;
